import React from "react";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons
import Chat from "@material-ui/icons/Chat";
import VerifiedUser from "@material-ui/icons/VerifiedUser";
import Fingerprint from "@material-ui/icons/Fingerprint";
import GroupWork from "@material-ui/icons/GroupWork";
import Extension from "@material-ui/icons/Extension";
import WatchLater from "@material-ui/icons/WatchLater";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import InfoArea from "components/InfoArea/InfoArea.jsx";

import featuresStyle from "assets/jss/material-kit-pro-react/views/sectionsSections/featuresStyle.jsx";
import SectionVirtualIncubatorFeatures from "./SectionVirtualIncubatorFeatures";

function SectionLocalGovernmentFeatures({ ...props }) {
  const { classes, ...rest } = props;
  return (
    <div className="cd-section" {...rest}>
      <div className={classes.container}>
        {/* Feature 1 START */}
        <div className={classes.features1}>
          <GridContainer>
            <GridItem
              xs={12}
              sm={8}
              md={8}
              className={`${classes.mlAuto} ${classes.mrAuto}`}
            >
              <h2
                className={`${classes.title} ${classes.mlAuto} ${
                  classes.mrAuto
                }`}
              >
                Innovative Youth Training Incubator.
              </h2>
              <h5 className={classes.description}>
                We will bring together youth leaders from around NSW to share
                and learn from each other over 4 weeks online using the latest
                technology.
              </h5>
            </GridItem>
          </GridContainer>
        </div>
        {/* Feature 1 END */}
        <div className={classes.container}>
          <SectionVirtualIncubatorFeatures />
        </div>
        {/* Feature 3 START */}
        <div className={classes.features3}>
          <GridContainer>
            <GridItem
              xs={12}
              sm={8}
              md={8}
              className={`${classes.mlAuto} ${classes.mrAuto} ${
                classes.textCenter
              }`}
            >
              <h2 className={classes.title}>FAQs</h2>
            </GridItem>

            <GridItem xs={12} sm={6} md={6}>
              <InfoArea
                className={classes.infoArea}
                icon={Extension}
                title="Which young people can participate?"
                description="Any young person who is part of a leadership groups/council/committee or reference group from a local council or local community organisation can participate. We recommend young people between the ages of 16 - 24 years."
                iconColor="info"
              />
              <InfoArea
                className={classes.infoArea}
                icon={GroupWork}
                title="What type of technology is needed?"
                description="We will deliver all sessions on Zoom.com. Participants at minimum will need access to a computer and audio (microphone and speaker). Ideally they also will have video/web cam capabilities as will encourage video during the training sessions."
                iconColor="info"
              />
              <InfoArea
                className={classes.infoArea}
                icon={WatchLater}
                title="How long is each session?"
                description="We will be running this session for 4 weeks and each session will be 90 minutes long. We believe this is optimal time for online engagement."
                iconColor="info"
              />
              <InfoArea
                className={classes.infoArea}
                icon={Extension}
                title="How many participants from my organisation can attend?"
                description="We will accept upto 10 participants from your organisation for a fixed cost. So more the merrier! As this is a Pilot we are limiting total numbers to 50 participants and we would like multiple organisations to have their young people join so they can expand their own networks."
                iconColor="info"
              />
            </GridItem>
            <GridItem xs={12} sm={6} md={6}>
              <InfoArea
                className={classes.infoArea}
                icon={Extension}
                title="Will participants get to meet each other online?"
                description="Absolutely! This is one of the things we are most excited about. We will have speednetworking activities and encourage sharing and learning from this community of peers. All online."
                iconColor="info"
              />
              <InfoArea
                className={classes.infoArea}
                icon={GroupWork}
                title="What date does this incubator kick-off?"
                description="Week 1 will commence on 6th July 2020 which falls in the NSW school holidays. "
                iconColor="info"
              />
              <InfoArea
                className={classes.infoArea}
                icon={WatchLater}
                title="Can staff attend?"
                description="Yes staff can attend for free to observe young people."
                iconColor="info"
              />
              <InfoArea
                className={classes.infoArea}
                icon={Extension}
                title="How many participants from my organisation can attend?"
                description="We will accept upto 10 participants from your organisation for a fixed cost."
                iconColor="info"
              />
              <InfoArea
                className={classes.infoArea}
                icon={GroupWork}
                title="What is the cost for participation?"
                description="The cost per organisation is $300+gst and you can register upto 10 participants. This works out to be $30 per participant. You can substitute participation for each week. For example, if 1 of your young people cannot attend 1 session; you can nominate someone else to participate in their place."
                iconColor="info"
              />
            </GridItem>
          </GridContainer>
        </div>
      </div>
    </div>
  );
}

export default withStyles(featuresStyle)(SectionLocalGovernmentFeatures);
